import { UpdateSimpleStoreState } from '@om-fe/store';

export const liveSidebarNavSlice = 'live-sidebar-nav';

export interface LiveEventSportNavModel {
    readonly id: string;
    readonly name: string;
    readonly numberOfEvents: number;
    readonly shortName: string;
    readonly displayChildren: boolean;
    readonly childrenIds: string[];
}

export interface LiveEventSportNavStateModel extends UpdateSimpleStoreState<LiveEventSportNavModel> {
    readonly ready: boolean;
}
